<template>
    <div>
       <div v-if="isVisibleWait" class="modalWait">

            <div class="modalWait__content">
                <p class="modalWait__text">ВНИМАНИЕ! ВЫ БЕЗДЕЙСТВУЕТЕ 2 МИНУТЫ</p>
                <p>Этот заказ закроется автоматически через {{ countdown }} секунд</p>
                <div class="modalWait__buttons">
                <button class="green" @click="finishTasks">Закончить дела</button>
                <button class="red">Закрыть заказ</button>
                </div>
            </div>


        </div>
    </div>
</template>

  <script scoped>

export default {
  name: 'Wait',
  data() {
    return {
        isVisibleWait: false,
        countdown: 60,
        autoCloseTimer: null,
    };
  },
  mounted(){
    this.setupInactivityListeners();
  },
  beforeDestroy(){
    this.removeInactivityListeners();
  },
  methods: {
    resetInactivityTimer() {
      clearTimeout(this.inactivityTimer);
      this.inactivityTimer = setTimeout(() => {
        this.handleInactivity();
      }, 120000); // 2 минуты
    },
    handleInactivity() {
      console.log('Вы бездействуете 2 минуты.');
        this.countdown = 60;
        this.startCountdown();
        //this.isVisibleWait = true;
    },
    startCountdown() {
        clearInterval(this.autoCloseTimer);
        this.autoCloseTimer = setInterval(() => {
            this.countdown--;
            if (this.countdown <= 0) {
                clearInterval(this.autoCloseTimer);
                this.autoCloseTimer = null;
                //this.isVisibleWait = false;
            }
        }, 1000);
    },
    finishTasks(){
        clearInterval(this.autoCloseTimer);
        this.autoCloseTimer = null;
        //this.isVisibleWait = false;
    },
    setupInactivityListeners() {
      const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];
      events.forEach(event => window.addEventListener(event, this.resetInactivityTimer));
      this.resetInactivityTimer(); // Стартуем отсчёт
    },
    removeInactivityListeners() {
      const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];
      events.forEach(event => window.removeEventListener(event, this.resetInactivityTimer));
      clearTimeout(this.inactivityTimer);
    },
  }
};
</script>


<style scoped>

.modalWait {
  position: fixed;
  display:none;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modalWait__content {
  background: white;
  padding: 30px;
  border-radius: 10px;
  text-align: center;
}

.modalWait__text {
  font-size: 18px;
  margin-bottom: 20px;
  font-weight: bold;
}

.modalWait__buttons button {
  margin: 0 10px;
  padding: 10px 20px;
  cursor: pointer;
  color: #fff;
}
.modalWait button.red {
    background: red;
}
.modalWait button.green {
    background: #21b889;
}

</style>